import { PendingSettingsInvite } from 'components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentIcon, DocumentIcon } from 'static';

import {
  CommentIconWrapper,
  DocIconWrapper,
  IconBadge,
  StyledItemPlaceholder,
  StyledTab,
  TabBottomIndicator,
  TabLabel,
  TabPill,
} from './styled';

interface TabProps {
  label: string;
  iconLabel?: boolean;
  grow?: boolean;
  activeTab: number;
  invitesCount?: number;
  badgeCount?: number;
  tabId?: string;
  index: number;
  onClickTab: (index: number) => void;
  isSidebar?: boolean;
  withBottomIndicator?: boolean;
}

const Tab: FC<TabProps> = ({
  label,
  iconLabel,
  grow,
  activeTab,
  invitesCount,
  badgeCount,
  tabId,
  index,
  onClickTab,
  isSidebar,
  withBottomIndicator,
}) => {
  const { t } = useTranslation();
  const onClick = () => {
    onClickTab(index);
  };

  const renderIcon = () => {
    switch (label) {
      case t('common.documentation'):
        return (
          <DocIconWrapper isActive={activeTab === index}>
            <DocumentIcon width={18} height={18} />
            {(badgeCount ?? 0) > 0 ? <IconBadge>{badgeCount}</IconBadge> : null}
          </DocIconWrapper>
        );
      case 'comment':
        return (
          <CommentIconWrapper isActive={activeTab === index}>
            <CommentIcon width={18} height={18} />
            {(badgeCount ?? 0) > 0 ? <IconBadge>{badgeCount}</IconBadge> : null}
          </CommentIconWrapper>
        );
      default:
        return null;
    }
  };

  const isActive = activeTab === index;
  const tabContent = iconLabel ? (
    renderIcon()
  ) : (
    <TabLabel isActive={isActive}>{label}</TabLabel>
  );

  return (
    <>
      {label.length > 0 ? (
        <>
          {grow && <StyledItemPlaceholder />}
          <StyledTab
            isActive={isActive}
            onClick={onClick}
            isSidebar={isSidebar}
            withBottomIndicator={withBottomIndicator}
          >
            {withBottomIndicator ? (
              <TabPill isActive={isActive}>{tabContent}</TabPill>
            ) : (
              tabContent
            )}
            {withBottomIndicator ? <TabBottomIndicator aria-hidden /> : null}
            {tabId === 'request' && invitesCount > 0 && (
              <PendingSettingsInvite
                invitesCount={invitesCount}
                addCss={{ right: -7 }}
              />
            )}
          </StyledTab>
        </>
      ) : null}
    </>
  );
};

export default Tab;
